import { appSettingsSlice, propertySlice, userSlice } from './slices'

export const reducer = {
  appSettings: appSettingsSlice.reducer,
  property: propertySlice.reducer,
  user: userSlice.reducer,
}
